var _excluded = ["labelId", "defaultMessage", "color", "fontFamily", "inverse", "fontSize", "iconSize", "iconWidth"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { mergeClasses } from '../../classify';
import { Check as CheckIcon } from 'react-feather';
import defaultClasses from './checkbox.css';
import { FormattedMessage } from "react-intl";
import Icon from "../Icon";

/* TODO: change lint config to use `label-has-associated-control` */
/* eslint-disable jsx-a11y/label-has-for */

var Checkbox = props => {
  var {
      labelId,
      defaultMessage,
      color,
      fontFamily,
      inverse,
      fontSize,
      iconSize = 12,
      iconWidth = 4
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  var checkmark = /*#__PURE__*/React.createElement(Icon, {
    src: CheckIcon,
    color: 'white',
    attrs: {
      strokeWidth: iconWidth
    },
    size: iconSize
  });
  var classes = mergeClasses(defaultClasses, props.classes);
  return /*#__PURE__*/React.createElement("label", {
    style: {
      color: color ? color : 'var(--color-darkgray)',
      fontFamily: fontFamily ? fontFamily : 'var(--fonts-poppins-medium)',
      fontSize: fontSize ? fontSize : '1rem'
    },
    className: inverse ? classes.inverseContainer : classes.container
  }, !inverse && /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    className: classes.input
  }, restProps)), /*#__PURE__*/React.createElement("span", {
    className: classes.icon
  }, checkmark)), labelId && defaultMessage ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: labelId,
    defaultMessage: defaultMessage
  })) : null, inverse && /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    className: classes.input
  }, restProps)), /*#__PURE__*/React.createElement("span", {
    className: classes.icon
  }, checkmark)));
};

/* eslint-enable jsx-a11y/label-has-for */

export default Checkbox;